import React from 'react';
import Relay from 'react-relay';

import { FAMILY_STANDARD_BOLD } from 'depop/styles/typography';

import { style } from 'glamor';

class UserPictureFallback extends React.Component {
  props: {
    user: Object,
  };

  render() {
    const { user } = this.props;

    return (
      <div
        {...style({
          width: '100%',
          height: '100%',
        })}>
        <svg
          viewBox="0 0 120 120"
          width="100%"
          height="100%"
          {...style({ marginBottom: '-3px' })}>
          <circle cx="60" cy="60" r="60" fill="#CCC" />
          <text
            dy=".35em"
            {...style({
              textAnchor: 'middle',
              fontFamily: FAMILY_STANDARD_BOLD,
            })}
            x="50%"
            y="50%"
            fill="#FFF"
            fontFamily={FAMILY_STANDARD_BOLD}
            fontSize="50">
            {user.initials}
          </text>
        </svg>
      </div>
    );
  }
}

export default Relay.createContainer(UserPictureFallback, {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        initials
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/images/UserPictureFallback.js